var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 470 470",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M469.988,75c0-1.302-0.242-2.609-0.757-3.846l-25-60C442.678,7.427,439.037,5,435,5s-7.678,2.427-9.23,6.154l-25,60 c-0.516,1.237-0.757,2.544-0.757,3.846H400v340v40c0,5.523,4.478,10,10,10h50c5.522,0,10-4.477,10-10v-40V75H469.988z M435,41 l10,24h-20L435,41z M450,445h-30v-20h30V445z M450,405h-30V85h30V405z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,0H35c-5.523,0-10,4.477-10,10v30H10C4.477,40,0,44.477,0,50v410c0,5.523,4.477,10,10,10h320c5.522,0,10-4.477,10-10 v-30h30c5.522,0,10-4.477,10-10V10C380,4.477,375.522,0,370,0z M320,450H20V60h300V450z M360,410h-20V50c0-5.523-4.478-10-10-10 H45V20h315V410z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 80,
    width: 65,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 120,
    width: 65,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 180,
    width: 205,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 220,
    width: 260,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 260,
    width: 260,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 300,
    width: 260,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 340,
    width: 260,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 380,
    width: 215,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 380,
    width: 30,
    height: 20
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.0ed6bc7c87e068fc0d92978daa4043c8.svg";
export { ForwardRef as ReactComponent };